import css from "styled-jsx/css";

export default css`
  .width-50 {
    width: 48%;
  }

  .width-100 {
    width: 100%;
  }

  .title {
    width: 90%;
    height: 40px;
    margin-bottom: 1rem;
    border-radius: 8px;
  }

  .tvPackage {
    width: 70%;
    height: 80px;
    margin-top: 1rem;
    margin-bottom: 1rem;
    border-radius: 8px;
  }

  .tv-buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
  }

  .tvButton {
    width: 280px;
    height: 60px;
    border-radius: 8px;
    margin-bottom: 1rem;
  }

  .tv-platforms {
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
  }

  .tvPlatform {
    width: 250px;
    height: 140px;
    border-radius: 8px;
    margin-bottom: 1rem;
  }

  .new-faker-tv-detail {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    &--title {
      height: 1rem;
      width: 20%;
    }
    &--card {
      height: 190px;
      border-radius: 8px;
    }
    &--plataform {
      height: 150px;
      border-radius: 8px;
    }
    &--grid-container {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(calc(50% - 0.5rem), 1fr));
      gap: 1rem;
    }
    &--grid-container-platafform {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(calc(50% - 0.5rem), 1fr));
      gap: 1rem;
    }
  }

  @media screen and (min-width: 1024px) {
    .tv-buttons {
      justify-content: space-between;
    }
    .tvButton {
      margin-bottom: 0rem;
    }
    .tv-platforms {
      justify-content: space-between;
    }
    .tvPlatform {
      margin-bottom: 0rem;
    }
    .faker-tv-detail {
      display: flex;
      justify-content: space-between;
    }
    .tv {
      width: 60%;
    }
    .banners {
      width: 30%;
    }
    .new-faker-tv-detail {
      width: 60%;
      &--grid-container-platafform {
        display: grid;
        grid-template-columns: repeat(
          auto-fill,
          minmax(calc(25% - 0.75rem), 1fr)
        );
        gap: 1rem;
      }
    }
  }
`;
